import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-form-flex',
  imports: [FormlyModule],
  template: `
    <div data-debug="flex-layout" class="content formly-form-flex">
      @for (f of field.fieldGroup; track f) {
        <formly-field [field]="f"></formly-field>
      }
    </div>
  `,
  styles: [
    `
      :host ::ng-deep .mat-mdc-form-field-infix {
        width: auto;
      }

      .formly-form-flex {
        flex: 1 1 0;
      }
    `,
  ],
})
export class FlexLayoutComponent extends FieldType {}
